module.exports = __webpack_public_path__ + "img/hero_image_clinical_researches.be7aa83.jpg";